
import { defineComponent } from 'vue';
import { Document } from '@element-plus/icons-vue';

export default defineComponent({
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  render() {
    // todo：暂时处理，之后接入UI设计的iconfont
    const { icon: iconName, title } = this;
    return [
      iconName === 'document' ? (
        <el-icon style="top: 2px;">
          <Document />
        </el-icon>
      ) : null,
      title ? <span>{title}</span> : null,
    ].filter(Boolean);
  },
});
